(function () {
  'use strict';

  function build(marquee) {
    if (!marquee || marquee.getAttribute('data-marquee-done') === 'true') return true;

    var track = marquee.querySelector('.announcement-bar__track');
    var group = marquee.querySelector('[data-announcement-group]');
    if (!track || !group) return false;

    var groupWidth = group.getBoundingClientRect().width;
    if (!groupWidth || groupWidth < 5) return false; // not ready; poller retries

    var viewport = marquee.getBoundingClientRect().width || window.innerWidth;

    // Clear anything generated by a previous run
    var gen = track.querySelectorAll('[data-announcement-gen]');
    for (var i = 0; i < gen.length; i++) gen[i].parentNode.removeChild(gen[i]);

    // 1) Repeat the group until the row is at least as wide as the viewport,
    //    so the strip is always full (no "scroll a little then reset" look).
    var repeats = Math.max(1, Math.ceil(viewport / groupWidth));
    for (var r = 1; r < repeats; r++) {
      var rep = group.cloneNode(true);
      rep.setAttribute('aria-hidden', 'true');
      rep.setAttribute('data-announcement-gen', '');
      rep.removeAttribute('data-announcement-group');
      track.appendChild(rep);
    }

    // unitWidth = width of one full "screen-filling" set (all current children)
    var unitWidth = groupWidth * repeats;

    // 2) Clone that whole unit once more for the seamless -50% loop.
    //    Duplicate every current child (the original group + its repeats).
    var currentChildren = track.children;
    var snapshot = [];
    for (var c = 0; c < currentChildren.length; c++) snapshot.push(currentChildren[c]);
    for (var s = 0; s < snapshot.length; s++) {
      var dup = snapshot[s].cloneNode(true);
      dup.setAttribute('aria-hidden', 'true');
      dup.setAttribute('data-announcement-gen', '');
      dup.removeAttribute('data-announcement-group');
      track.appendChild(dup);
    }

    // 3) Speed is px/second. Duration to move one unit = unitWidth / speed.
    var speed = parseFloat(marquee.getAttribute('data-speed')) || 60;
    var duration = unitWidth / speed;
    marquee.style.setProperty('--marquee-duration', duration + 's');

    marquee.classList.add('is-running');
    marquee.setAttribute('data-marquee-done', 'true');
    return true;
  }

  function buildAll() {
    var list = document.querySelectorAll('[data-announcement-marquee]');
    if (!list.length) return false;
    var done = true;
    for (var i = 0; i < list.length; i++) if (!build(list[i])) done = false;
    return done;
  }

  function reset() {
    var list = document.querySelectorAll('[data-announcement-marquee]');
    for (var i = 0; i < list.length; i++) {
      list[i].removeAttribute('data-marquee-done');
      list[i].classList.remove('is-running');
    }
    buildAll();
  }

  var tries = 0;
  var timer = setInterval(function () {
    tries++;
    if (buildAll() || tries > 80) clearInterval(timer);
  }, 100);

  if (document.fonts && document.fonts.ready) document.fonts.ready.then(buildAll);
  window.addEventListener('load', buildAll);
  window.addEventListener('pageshow', buildAll);

  var rt;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(reset, 250);
  });

  document.addEventListener('shopify:section:load', reset);
})();
